module.exports = __webpack_public_path__ + "img/7.52816add.png";